import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; 
import Navbar from '../Component/navbar.jsx';
import Footer from "../Component/footer.jsx";
import { API_URL } from '../apiConfig';
import CSRFToken from '../cookies.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import Crown from '../image/crown.png';
import './Pricing.css';

const Pricing = () => {
  const navigate = useNavigate();
  const [plans, setPlans] = useState([]);
  const [selectedProPlan, setSelectedProPlan] = useState(null);
  const [proPlans, setProPlans] = useState([]);
  const [dnd,setDnd] = useState([]);

  const fetchPricingData = async () => {
    const authToken = localStorage.getItem('access');
    const isAuthenticated = !!authToken;
    const method = isAuthenticated ? 'POST' : 'GET';
    const headers = {
      'Content-Type': 'application/json',
    };
  
    if (isAuthenticated) {
      headers['Authorization'] = `Bearer ${authToken}`;
      headers['X-CSRFToken'] = CSRFToken(document.cookie);
    }
  
    try {
      const response = await fetch(`${API_URL}/pricing`, {
        method: method,
        headers: headers,
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const data = await response.json();
      setPlans(data.plans);
  
      // Filter the plans based on is_subscribed field
      const dndPlans = data.plans.filter(plan => plan.is_subscribed === true);
      setDnd(dndPlans);

      const filteredPlans = data.plans.filter(plan => plan.is_subscribed === false || plan.is_subscribed === undefined);
      setPlans(filteredPlans);

      const proPlansData = filteredPlans.filter(plan => plan.plan_type === 'Pro');
      setProPlans(proPlansData);
  
      const initialProPlan = proPlansData[0];
      setSelectedProPlan(initialProPlan);
    } catch (error) {
      console.error('Error:', error);
    }
  };
  

  useEffect(() => {
    fetchPricingData();
  }, []);

  const handleProPlanClick = (planName) => {
    const selectedPlan = proPlans.find(plan => plan.plan_name.toLowerCase() === planName.toLowerCase());
    setSelectedProPlan(selectedPlan);
  };

  const handleCheckout = (planId) => {
    console.log("Planid",planId)
    console.log(dnd);
    if(dnd?.length === 0){
    navigate(`/checkout?plan_id=${planId}`);  // Navigate to checkout page with plan_id
    }
  };

  // const getDiscountedPrice = (plan) => {
  //   return plan.plan_price - plan.plan_sale;
  // };

  const getDiscountedPriceMon = (plan) => {
    const out_price = plan.plan_price ;
    if(plan.duration_sufix === "monthly"){
      return `${out_price}/month`
    }
    // else if(plan.duration_sufix == "weekly"){
    //   return `${Math.ceil((out_price/plan.plan_duration)* 100) / 100}/day`
    // }
    else if(plan.duration_sufix === "quaterly"){
      return `${Math.ceil((out_price/(plan.plan_duration * (12/plan.intervals)))* 100) / 100}/month`
    }
    else if(plan.duration_sufix === "yearly"){
      return `${Math.ceil((out_price/(plan.plan_duration * (12/plan.intervals)))* 100) / 100}/month`
    }
  };

  return (
    <div className='flex flex-col min-h-screen bg-white'>
      <Navbar />
      <main className="flex items-center justify-center h-auto my-20">
        <div className="flex flex-col justify-center items-center h-full w-full lg:min-w-[900px] px-4">
          <span className="big-circle"></span>
          <div className="my-2 font-bold text-7xl">Choose your plan.</div>
          <div className='my-2 text-base'>Unlock more career possibilities with Hirebeen Premium.</div>

          <div className="flex flex-col items-center justify-center w-full mt-6 md:flex-row">
            {plans.map((plan) => (
              plan.plan_type === "Basic" ? (
                <div key={plan.plan_name} className="min-w-[300px] min-h-[400px] p-3 border-1 my-4 md:mb-0 md:mx-4 rounded-2xl overflow-x-auto overflow-y-auto shadow-2xl bg-[rgb(250,250,251)] hover:bg-[rgba(232,234,246,1)] hover:border-orange-400 transform hover:scale-105 transition-transform">
                  <div className="flex flex-col justify-between items-start h-1/3 px-4 pt-4 pb-0 text-[#0d0d0d]">
                    <h3 className="text-2xl font-light tracking-widest uppercase">{plan.plan_name}</h3>
                    <div className='text-3xl font-bold'>₹{plan.plan_price - plan.plan_sale}</div>
                    <div className="text-xs font-light">Valid for {plan.plan_duration} {plan.duration_sufix}</div>
                    <hr className="w-11/12 mt-2 border-t-[rgba(245,245,245,0.7)]" />
                  </div>
                  <div className="flex flex-col min-h-[300px] justify-between py-4">
                    <ul className="px-8 space-y-2 text-gray-800 list-none">
                      {JSON.parse(plan.plan_description).map((desc, index) => (
                        <li key={index} className="text-base">
                          <FontAwesomeIcon icon={faCheck} className="text-[#1d6362] mr-4" />
                          {desc}
                        </li>
                      ))}
                    </ul>
                    <button className="block w-[160px] py-2 mx-auto mt-8 text-lg bottom-2 font-semibold border-2 uppercase rounded-full transition-colors">
                      Active
                    </button>
                  </div>
                </div>
              ) : null
            ))}

            {selectedProPlan && (
              <div className="w-auto h-auto p-3 border-1 my-4 md:mb-0 md:mx-4 rounded-2xl overflow-x-auto overflow-y-auto shadow-2xl bg-[rgb(250,250,251)] hover:bg-[rgba(232,234,246,1)] hover:border-orange-400 transform hover:scale-105 transition-transform">
                <div className="flex flex-col justify-between items-start h-1/3 px-4 pb-0 text-[#0d0d0d]">
                  <div className='flex flex-wrap items-center my-2 '>
                    <span className="text-xs font-bold float-start">
                      <img src={Crown} alt="Crown" className='w-5 h-5 mx-1' />
                    </span>
                    <span className="font-semibold text-md float-start">{selectedProPlan.plan_name} Plan</span>
                    {(selectedProPlan.plan_sale / selectedProPlan.plan_price) !== 0 &&
                    <span className="text-xs font-bold float-end pl-20 pt-[-10px]">
                      <div className='bg-[#ffd22e] p-2'>
                        <del>₹{selectedProPlan.plan_sale}</del> - <b>save {100-(Math.ceil((selectedProPlan.plan_price / selectedProPlan.plan_sale) * 100))}%</b>
                      </div>
                    </span>}
                  </div>
                  <h3 className="text-2xl font-light tracking-widest uppercase">PRO</h3>
                  <div className='text-3xl font-bold'>₹{getDiscountedPriceMon(selectedProPlan)}</div>
                  <div className="text-xs font-light">₹{selectedProPlan.plan_price} will be billed {selectedProPlan.plan_name.replace("Pro ", "")}</div>
                  <div className="relative flex pt-3">
                    {proPlans.map((plan) => (
                      <div
                        key={plan.plan_name}
                        id={plan.plan_name}
                        className={`mr-3 text-sm cursor-pointer font-weight-700 hover:border-2 hover:border-b-green-500 transition delay-2000 ${selectedProPlan.plan_name.toLowerCase() === plan.plan_name.toLowerCase() ? 'border-b-green-500' : ''}`}
                        onClick={() => handleProPlanClick(plan.plan_name)}
                      >
                        {plan.plan_name}
                      </div>
                    ))}
                    <div className="absolute left-0 w-[83px]"></div>
                  </div>
                  <hr className="w-11/12 mt-2 border-t-[rgba(245,245,245,0.7)]" />
                </div>
                <div className="flex flex-col justify-between py-4 h-2/3">
                  <ul className="px-8 space-y-2 text-gray-800 list-none">
                    {JSON.parse(selectedProPlan.plan_description).map((desc, index) => (
                      <li key={index} className="text-base">
                        <FontAwesomeIcon icon={faCheck} className="text-[#1d6362] mr-4" />
                        {desc}
                      </li>
                    ))}
                  </ul>
                  <button onClick={() => handleCheckout(selectedProPlan.rp_plan_id)} className="block w-[160px] py-2 mx-auto mt-8 text-lg font-bold text-white uppercase rounded-full bg-[#1d6362] hover:bg-orange-500 transition-colors">
                    Buy it
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Pricing;
